
import { Vue, Component, Prop } from "vue-property-decorator";
import ProjectModal from "@/components/companyProjects/ProjectModalNew.vue";
import UiButton from "@/components/button/ui-button.vue";
import TagIcon from "@/components/icons/TagIconNew.vue";
import ClientEditModal from "@/components/companyProjects/ClientEditModal.vue";
import EditIconHover from "@/components/icons/EditIconHover.vue";
import { Project, User } from "@/generated/graphql";
import GET_PROJECT_CLIENT from "@/apollo/projectActivities/GetProjectClient.gql";
import GET_PROJECT_CARE_PLAN from "@/apollo/projectActivities/GetProjectCarePlan.gql";
import LoadingOverlay from "../common/LoadingOverlay.vue";

@Component({
    components: {
        UiButton,
        ClientEditModal,
        TagIcon,
        ProjectModal,
        EditIconHover,
        LoadingOverlay,
    },
})
export default class ProjectSchedulerEdit extends Vue {
    @Prop({ type: Object, default: undefined }) readonly project?: Project;

    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Boolean, required: true }) modalShown!: boolean;


    isHovered: boolean = false;
    isCareplanExist: boolean = false;
    initialProject: Project = undefined;
    currentEditTab = { tab: 0, step: 0 };
    loading: boolean = false;

    async created() {
        await this.fetchData();
    }
    async fetchData() {
        try {
            this.loading = true;
            // Fetch project data
            const projectQuery = this.$apollo.query({
                query: GET_PROJECT_CLIENT,
                variables: {
                    where: { id: { _eq: this.project.id } },
                },
            });

            // Fetch care plan data
            const carePlanQuery = this.$apollo.query({
                query: GET_PROJECT_CARE_PLAN,
                variables: {
                    project_id: this.project.id,
                },
            });

            // Wait for both queries to complete
            const [projectResult, carePlanResult] = await Promise.all([
                projectQuery,
                carePlanQuery,
            ]);

            // Check if care plan exists
            this.isCareplanExist =
                carePlanResult.data.client_care_plan &&
                carePlanResult.data.client_care_plan.length > 0;

            // Extract data from results
            const projectData = projectResult.data.project[0] || {};
            const carePlanData = carePlanResult.data.client_care_plan[0] || {};

            // Merge data only when both are available
            this.initialProject = this.customMerge(projectData, carePlanData);
            this.loading = false;
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
    customMerge(projectData, carePlanData) {
        const mergedData = { ...projectData }; // Start with project data

        // Iterate over carePlanData and add only non-overlapping fields
        for (const key in carePlanData) {
            if (!(key in projectData)) {
                mergedData[key] = carePlanData[key];
            }
        }

        return mergedData;
    }

    handleClose(): void {
        this.$emit('close')
        window.location.reload();

    }
    hanldeCancel(): void {
        this.$emit('close')
    }
    get buttonText(): string {
        if (this.project) {
            return "Edit Project";
        }

        return "Add Project";
    }
}
